// extracted by mini-css-extract-plugin
export default {"container":"style_container__+z4eb","map":"style_map__dIBc8","graph1":"style_graph1__V4Bu3","graph2":"style_graph2__ViFAt","graphs":"style_graphs__I3Omw"};